export default __webpack_public_path__ + "static/media/001-anatomy.4ae24c39.svg";